module.exports = "https://assets.calmac.co.uk/scripts/apps/site-services/1.8/img/winterTimetable.svg";